import http from "@/plugins/axios";

export default {
    actions: {
        async getRegions() {
            try {
                const {data: {data}} = await http.get('admin/users/regions')
                return Promise.resolve(data)
            } catch (e) {
                return Promise.reject(e)
            }

        },
        async getDistrict(_, id) {
            try {
                const {data: {data}} = await http.get(`admin/users/districts/${id}`)
                return Promise.resolve(data)
            } catch (e) {
                return Promise.reject(e)
            }

        },
        async getTariffs(_) {
            try {
                const {data: {data}} = await http.get(`admin/tariffs`)
                return Promise.resolve(data)
            } catch (e) {
                return Promise.reject(e)
            }
        },
        async getMkos(_) {
            try {
                const {data: {data}} = await http.get(`admin/mko`)
                return Promise.resolve(data)
            } catch (e) {
                return Promise.reject(e)
            }
        },
        async getWorkers(_, params) {
            if(!params) params = {}
            try {
                const {data: {data}} = await http.get('admin/workers/list', {params})
                return  Promise.resolve(data)
            } catch (e) {
                return Promise.reject(e)
            }
        }
    }
}